module.exports = __webpack_public_path__ + "static/img/sousuo.7b2a3bd0.svg";